module.exports = __webpack_public_path__ + "static/img/checked-product-bg.c160b67a.png";